import { render, staticRenderFns } from "./GeneralSpecialties.vue?vue&type=template&id=59331129&"
import script from "./GeneralSpecialties.vue?vue&type=script&lang=js&"
export * from "./GeneralSpecialties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports